import i18n from '@/i18n'
import {filterRulesMapped} from '@/tools/filterRules'
import { gpsService } from '@/services/gps.service'
import { mapActions, mapGetters } from 'vuex'
import {DialogType, SnackbarStyle} from '@/constants/constants'
import GpsDialogComponent from "@/components/gps/dialog/GpsDialogComponent.vue"
import LineDialogComponent from "@/components/line/dialog/LineDialogComponent.vue"
import { dialogTypes } from "@/constants/dialogTypes"
import {DialogGPS, dialogUtil} from "@/tools/dialog"
import { clone } from 'ramda'
import Vue from 'vue'
import moment from 'moment'
import GpsHistoryComponent from './history/GpsHistoryComponent.vue'
import BreadcrumbComponent from '@/components/commons/report-breadcrumb/BreadcrumbComponent.vue'

export default {
    name: 'GpsABMComponent',
    components: {
        GpsDialogComponent,
        LineDialogComponent,
        GpsHistoryComponent,
        BreadcrumbComponent
    },
    data: () => ({
        tabsGpsHistory: [
            {
                id: 'tab-gps-abm',
                name: i18n.t('gps.name')
            }
        ],
        selectedTabGpsHistory: 'tab-gps-abm',
        breadcrumbButtomsGpsHistory: [],
        // headers
        tableHeaders: [],
        // reglas de filtrado
        tableFilterRules: {},
        // datos de la tabla
        tableData: [],
        // key de los datos
        tableDataKey: '_id',
        // botones de cada fila
        rowActions: [
            {
                id: 1,
                name: i18n.t('modify'),
                color: 'blue',
                icon: 'fa-pen'
            },
            {
                id: 2,
                name: i18n.t('delete'),
                color: 'red',
                icon: 'fa-trash-alt'
            },
            {
                id: 3,
                name: i18n.t('history'),
                color: 'blue',
                icon: 'history'
            }
        ],
        // botones del componente
        tableComponentButtons: [],
        // tamaño de página
        pageSize: 50,
        // número de página
        pageNumber: 1,
        // total de documentos en la collection de la base de datos
        pageTotal: 0,
        // diálogo
        dialog: {
            ...dialogTypes.MODULO,
        },
        // variable para mostrar / ocultar el dialog
        showEditDialog: false,
        // título del dialog
        editDialogTitle: i18n.t('gps.editDialog.titleNew'),
        // loading para la tabla
        loadingTable: true
    }),
    computed: {
        /**
         * getters del breadcrumb para el dialog
         */
        ...mapGetters('breadcrumbs', [
            'getBread'
        ])
    },
    created() {
        /*
            Vuex watch del breadcrumb
        */
        this.unwatch = this.$store.watch(
            (state, getters) => getters['breadcrumbs/getBread'],
                (newBreads) => {
                    const lastElemet = newBreads[newBreads.length - 1]
                    if (!lastElemet) {
                        this.cancel()
                        return
                    }
                    this.dialog = dialogUtil.getDialog(lastElemet.key, DialogGPS)
                },
            { deep: true })
    },
    beforeDestroy() {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch()
        this.cleanBread()
        // reset report breadcrumb
        this.reset()
    },
    mounted() {
        // inicialización de los datos del ABM
        this.initialize()
    },
    methods: {
        /**
         * actions del breadcrumbs
         */
        ...mapActions('breadcrumbs', [
            'pushBread',
            'cleanBread'
        ]),
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        ...mapActions('reportBreadcrumb', [
            'setEntitySelectorItems',
            'setEntitySelectorConfiguration',
            'reset',
            'setSelectedItem'
        ]),
        /**
         * Para inicializar el componente
         */
        async initialize () {
            // Botón de eliminación múltiple
            this.tableComponentButtons.push(
                {
                    id: 'edit-dialog',
                    tooltip: i18n.t('add'),
                    icon: 'add',
                    action: this.showCreationDialog.bind(this),
                    selectedData: false
                },
                {
                    id: 'masive-delete',
                    tooltip: i18n.t('multipleDelete'),
                    icon: 'delete_outline',
                    action: this.multipleDelete.bind(this),
                    selectedData: true
                })

            // total de gpss (para el paginador)
            this.pageTotal = await gpsService.getTotal()

            // Si hay query params en la URL, los setea para incluirlos en la llamada al backend
            if (this.$route.query.pageSize && this.$route.query.pageNumber) {
                this.pageSize = Number(this.$route.query.pageSize)
                this.pageNumber = Number(this.$route.query.pageNumber)

                // Valida que los qery params sean correctos y completos
                if ((this.pageSize && this.pageSize <= 0) || (this.pageNumber && this.pageNumber <= 0) || (this.pageNumber && !this.pageSize) || (!this.pageNumber && this.pageSize)) {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('error.invalidQueryParams'),
                        timeout: 6000,
                        style: SnackbarStyle.ERROR
                    })
                    this.pageSize = this.pageTotal
                    this.pageNumber = 1
                }
            } else {
                this.pageSize = 50
                this.pageNumber = 1
            }

            // cargo la tabla con las cosas filtradas de acuerdo a los valores del selector
            this.getData()
            this.resetFields()
            this.openGps()
        },
        tabSelectedGpsHistory (id) {
            this.selectedTabGpsHistory = id
        },
        /**
         * Refrescar la data
         */
        refreshTable() {
            this.getData(true)
        },
        /**
         * Datos de la tabla
         * @param {*} update
         */
        async getData(update = false) {
            this.loadingTable = true
            if (update) {
                this.pageTotal = await gpsService.getTotal()
                this.pageSize = 50
                this.pageNumber = 1
            }
            const data = await gpsService.findAll(this.pageSize, this.pageNumber, !update)
            const lastTableHeaders = clone(this.tableHeaders)
            this.tableData.cleanAndUpdate(data.data)
            if (update) {
                const that = this
                Vue.nextTick(function () {
                    that.tableHeaders.cleanAndUpdate(lastTableHeaders)
                })
            } else {
                this.tableHeaders.cleanAndUpdate(data.headers)
                this.setTableFilterRules()
            }
            this.loadingTable = false
        },
        /**
         * Reglas de filtrado de la tabla
         */
        setTableFilterRules() {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
        /**
         * Eliminación
         * @param {*} data
         */
        async delete(data) {
            gpsService.deleteOne(data._id).then(() => {
                this.getData(true)
            })
        },
        /**
         * Eliminación múltiple
         * @param {*} data
         */
        async multipleDelete(data) {
            this.openDialog({
                title: this.$t('delete'),
                text: this.$t('gps.multipleDeleteMessage'),
                type: DialogType.QUESTION,
                overlayOpacity: 0.5,
                actionButtons: true,
                yesAction: async () => {
                    const ids = data.map(e => e._id)
                    const that = this
                    gpsService.deleteMany(ids).then(() => {
                        that.getData(true)
                    })
                },
                noAction: () => {
                }
            })
        },
        /**
         * Acciones ejecutadas por los botones de cada fila de datos
         * @param {*} button
         * @param {*} data
         */
        rowButtonClicked(button, data) {
            const items = [];
            switch (button.id) {
                case 1:
                    // TO DO: agregar el id como query param
                    this.loadFields(data)
                    break
                case 2:
                    this.openDialog({
                        title: this.$t('delete'),
                        text: this.$t('gps.deleteMessage', {unitId: data.unitId}),
                        type: DialogType.QUESTION,
                        overlayOpacity: 0.5,
                        actionButtons: true,
                        yesAction: () => {
                            this.delete(data)
                        },
                        noAction: () => {
                        }
                    })
                    break
                case 3:
                    this.setEntitySelectorConfiguration({ name: this.$t('gps.unitId'), value: 'id', text: 'nameUnit' })
                    this.tableData.forEach(module => {
                        if (module._id && module.unitId) {
                            items.push({
                                id: module._id,
                                nameUnit: module.unitId
                            })
                        }
                    })
                    this.setEntitySelectorItems(items)
                    this.setSelectedItem({
                        id: data._id,
                        nameUnit: data.unitId,
                    })
                    if (this.tabsGpsHistory.filter(tab => tab.id === 'tab-gps-history').length === 0) {
                        this.tabsGpsHistory.push({
                            id: 'tab-gps-history',
                            name: i18n.t('gps.record')
                        })
                    }
                    this.selectedTabGpsHistory = 'tab-gps-history'
                    break;
                default:
                    console.log('default')
            }
        },
        /**
         * Para cargar el diálogo con datos para actualizar
         * @param {*} data
         */
        loadFields(data) {
            const modelData = this.dialog.model
            Object.assign(modelData, data)
            modelData.buyDate = data.buyDate ? moment(data.buyDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
            this.showUpdateDialog()
        },
        /**
         * Dialog para creación
         */
        showCreationDialog() {
            this.openGps()
            this.dialog.model.update = false
            this.editDialogTitle = i18n.t('gps.editDialog.titleNew')
            this.showEditDialog = true
            this.resetFields()
        },
        /**
         * Diálogo para edición
         */
        showUpdateDialog() {
            this.openGps()
            this.dialog.model.update = true
            this.editDialogTitle = i18n.t('gps.editDialog.titleUpdate')
            this.showEditDialog = true
        },
        /**
         * Carga el breadcrumb
         */
        openGps() {
            const bread = {
                key: DialogGPS,
                disabled: true,
                text: this.$t('gps.name')
            }
            this.pushBread(bread)
        },
        /**
         * Para los clicks fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cuando se cancela el dialog
         */
        cancel() {
            this.resetFields()
            this.showEditDialog = false
        },
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            this.dialog.model = {
                unitId: null,
                brandId: null,
                modelId: null,
                buyDate: new Date().toISOString().substr(0, 10),
                firmware: null,
                serieNumber: null,
                selectItems: null,
                line1: null,
                line2: null,
                communicationModuleId: null,
                description: null,
                update: false,
                actualUnitId: null,
            }
        },
        /**
         * Paginador externo
         * @param {*} pageSize
         * @param {*} pageNumber
         */
        externalPaginator(pageSize, pageNumber) {
            this.pageNumber = Number(pageNumber)
            this.pageSize = Number(pageSize)
        }
    }
}
